function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function translateJuicer() {
    jQuery(function( $ ) {
        $('.j-paginate').text("Visa fler");
        $('.all').text("Alla");
        $('.juicer-feed .empty h2').text("Inga inlägg att visa för tillfället.");
    });
}

function expandSelectedStepsInExpandableModule()
{
    jQuery(function( $ ) {
        var step = getParameterByName('step');
        if (step != null)
        {
            var steps = step.split(',');
            for (var i = 0; i < steps.length; i++) {
                if ($.isNumeric(steps[i]))
                {
                    //var toggle = '#gk_toggle_div_' + steps[i];
                    var toggleLink = $(".gk_togglediv_inner a[data-expandid='" + steps[i] + "']");
                    if(toggleLink)
                    {
                        var toggle = $(toggleLink).siblings(".gk_toggle_content");
                        $(toggle).collapse('show');
                    }
                }
            }
        }
    });
}

var updateQueryStringParam = function (key, value) {

    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        urlHashString = document.location.hash,
        newParam = key + '=' + value,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        keyRegex = new RegExp('([\?&])' + key + '[^&]*');

        // If param exists already, update it
        if (urlQueryString.match(keyRegex) !== null) {
            params = urlQueryString.replace(keyRegex, "$1" + newParam);
        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }
    ;
    window.history.replaceState({}, "", baseUrl + urlHashString + params);
};

function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function removeParam(key) {

    var baseUrl = [location.protocol, '//', location.host, location.pathname].join('') + document.location.hash + document.location.search;
    var rtn = baseUrl.split("?")[0],
        param,
        params_arr = [],
        queryString = (baseUrl.indexOf("?") !== -1) ? baseUrl.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        rtn = rtn + "?" + params_arr.join("&");
    }
    if (endsWith(rtn, "/?") || (document.location.hash.length > 0 && endsWith(rtn, "?"))) {
        rtn = rtn.substring(0,rtn.length-1);
    }
    window.history.replaceState({}, "", rtn);
}
var childPages = false;

jQuery(document).ready(function($) {


    

    function set_event_back_link_from_parameter()
    {
        var link_page = getParameterByName('event_link_back');
        if ($.isNumeric(link_page)) {

            var event_link_back_page = $('.acf-fields').find("[data-name='event_link_back_page']");
            var event_type_of_link = $('.acf-fields').find("[data-name='event_type_of_link']");
            var event_link_back_title = $('.acf-fields').find("[data-name='event_link_back_title']");

            var pageselect = event_link_back_page.find('.acf-input>select');
            var pageinput = event_link_back_page.find('.acf-input>input');

            var back_link_option = new Option(link_page, link_page, true, true);
            pageselect.append(back_link_option).trigger('change');
            pageinput.val(link_page).trigger('change');

            event_link_back_page.hide();
            event_type_of_link.hide();
            event_link_back_title.hide();
        }
    }

    $('.btn-disabled').click( function (e) {
       e.preventDefault();
    });

    if ($('#acf-form-data').length)
    {
        set_event_back_link_from_parameter();
    }

    $('body').on('click', '.stratsys-more-years', function(){
        if ( $(this).hasClass( 'active' ) ) {
            $(this).removeClass('active btn-flat').closest('.stratsys-kpi-value').find('.stratsys-sub-row').slideUp();
        } else {
            $(this).addClass('active btn-flat').closest('.stratsys-kpi-value').find('.stratsys-sub-row').slideDown();
        }
    });


    if ($('.stratsys-comparison-service').length !== 0)
    {
        var stratsys_init_select = false;
        var stratsys_init_category = false;

        var afterhash = window.location.hash.substr(1);
        if (afterhash.indexOf('comparison') == -1)
        {
            $('.stratsys-comparison-service').css( "display", "none");
        }

        $(document).on('DOMNodeInserted', '.stratsys-button' ,function() {
            $('.stratsys-comparison-service').css( "display", "unset");
            if (!stratsys_init_select) {
                var selected = getParameterByName('sname');
                if (selected != null)
                {
                    setTimeout(select_if_stratsys_is_ready, 50);
                    stratsys_init_select = true;
                }
            }
        });
        $(document).on('DOMNodeInserted', '.stratsys-link-container' ,function() {
            if (!stratsys_init_category) {
                setTimeout(set_category_if_stratsys_is_ready, 50);
                stratsys_init_category = true;
            }
        });
    }

    $('.show-hide-map').click( function(){
        if ( $(this).hasClass('map-closed') ) {
            //ga('send', 'event', 'map', 'open');
            $(this).removeClass('map-closed').addClass('map-open');
            $('> span', this).html('Dölj karta');
            $('#gk-map').slideDown(500, function() {
                $("#map").css('height', $("#gk-map").innerHeight());
            });
        } else {
            $(this).removeClass('map-open').addClass('map-closed');
            $('> span', this).html('Visa på karta');
            $('#gk-map').slideUp();
        }
    });

    $('.temp-list .temp-item button').click( function(){
        if ( $(this).hasClass('open')) {
            $(this).removeClass('open').next().slideUp(200);
        } else {
            $(this).addClass('open').next().slideDown(200);
        }

    });

    function set_category_if_stratsys_is_ready()
    {
        if (!angular.element('.stratsys-cf').scope().$$phase) {
            var comparename =  $('.stratsys-comparison-service').data('comparison');
            $(".stratsys-link-text:contains('" + comparename + "')").parent().click();
        }
        else {
            setTimeout(set_category_if_stratsys_is_ready, 50);
        }
    }

    function select_if_stratsys_is_ready()
    {
        if (!angular.element('.stratsys-cf').scope().$$phase)
        {
            var selected = getParameterByName('sname');
            var stitle = $('h2.stratsys-title[title="' + selected + '"]');
            if (stitle.length) {
                var sbutton = stitle.parent().find('button');
                sbutton.click();
            }
            else {
                setTimeout(select_if_stratsys_is_ready, 50);
            }
        }
        else {
            setTimeout(select_if_stratsys_is_ready, 50);
        }
    }

    if( $('.place-hours').length !== 0  ) {
        var d = GK_WEEKDAY;

        // Set today
        $('[data-gk-places-weekday="' + d + '"]').addClass('active');
        // Show today first
        $('.place-hours a').each(function () {
            var parent = $(this);
            parent.children().each(function(index, child) {
                child = $(child);

                if(child.hasClass('active')) {
                    return false;
                }
                else {
                    $(child).detach().appendTo(parent);
                }
            });
        });
    }

    $('.show-hide-filters').click(function () {
        var mainDiv = $('.gk-filters');

        if( mainDiv.is(":visible") ) {
            
            $('.gk-filters .tag-list .list-item').removeClass('active');
            $('.gk-filters .search')[0].value = '';
            childPages.search('');
            filterPagesInList();

            $(this).addClass('closed').removeClass('open');
            mainDiv.addClass('rs_skip');
            mainDiv.hide();
            
        } else {
            //ga('send', 'event', 'filter', 'open');
            $(this).addClass('open').removeClass('closed');
            mainDiv.removeClass('rs_skip');
            mainDiv.show();
        }
    });


    var searchtimeout;
    
    jQuery(document).ready(function($) {

    $('#acf-field_5bacaffc4b512').click(function(){
        $('.lov-item').hide();
        $('.gilla-item').css("display","inline-block");
    });

    $('#acf-field_5bacaffc4b512-1781').click(function(){
        $('.gilla-item').hide();
        $('.lov-item').css("display","inline-block");
    });

    $('.print-list').click(function(){
        window.print();
    });

        var beforePrint = function() {
            
            if(false != childPages) {
                childPages.show(1, 9999);
                childPages.update();
            }
        };
        var afterPrint = function() {

            if(false != childPages) {
                childPages.show(1, 20);
                childPages.update();
            }
        };
    
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(function(mql) {
                if (mql.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
    
        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;
    });

    if ($('#list-wrapper').length !== 0) {
        var pagesize = 20;

        if(location.href.indexOf('page-size=all') > 0) {
            pagesize = 9999;
        }

        // Set options for list object.
        var options = {
            valueNames: [
                'gk-item-title',
                'gk-item-excerpt',
                'gk-item-meta-event-venue',
                {attr: 'data-categories', name: 'categories'},
                {attr: 'data-tags', name: 'tags'},
                {attr: 'data-startdate', name: 'startdate'},
                {attr: 'data-enddate', name: 'enddate'}
            ]
        };

        if ($('ul.pagination').length) {
            options.page = pagesize;
            options.pagination = [{
                    name: "pagination",
                    paginationClass: "pagination",
                    innerWindow: 1,
                    outerWindow: 1
                }];
        }
        // Create new list object.

        try {
            var doonce = false;
            childPages = new List('list-wrapper', options);
            childPages.on('updated', function(e) {

                if (doonce)
                    return;

                doonce = true;
                $(e.listContainer).on('click', function(e) {
                    var $target = $(e.target || e.srcElement);
                    if($target.hasClass('page'))
                    {
                        window.scrollTo(0,0);  
                        setfilterstate();
                    }
                });           
            });
        }
        catch (ex) {
        }
        
        // Controls when a filter chip is clicked.
        $('.tag-list .list-item').click(function () {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            } else {
                $(this).addClass('active');
                //ga('send', 'event', 'filter-tag', 'button', $(this).data('sort'));
            }
            filterPagesInList();
        });

        $(".input.hasDatepicker").change(function () {
            filterPagesInList();
        });

        var start_date_key = 'field_5a71b213bb73f'; // the field key of the start date
        var end_date_key = 'field_5a71b361bb740'; // the field key of the end date

        if (typeof(acf) != 'undefined') {
            acf.add_action('date_picker_init', function ($input, args, $field) {
                var key = $input.closest('.acf-field').data('key');
                if (key == start_date_key || key == end_date_key) {
                    $input.datepicker().on('input change select', function (e) {
                        if (key == start_date_key) {
                            var date = jQuery(this).datepicker('getDate');
                            var enddate = jQuery('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('getDate');
                            if (enddate != null && enddate < date) {
                                jQuery('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('setDate', date);
                            }
                        }
                        filterPagesInList();

                    });
                }
            });
        }
        handleFilterInputParameters();

        // Triggers click event when "Enter" key is pressed on a filter chip.
        $('.tag-list .list-item').keypress(function (e) {
            if (e.which == 13) {//Enter key pressed
                $(this).click();//Trigger search button click event
            }
        });

        $('.select-list .select-item').click(function () {
            $('.select-item').removeClass('active');
            $(this).addClass('active');
            var categoryname = $(this).data('name');
            $(this).parents('.select-container').first().find('.selected-value').text(categoryname);
            filterPagesInList();
        });

        function setfilterstate()
        {
            var input = encodeURIComponent($('#search-input').val());
            var tags = '';
            $('.tag-list > li.active').each(function() {
                if (tags.length > 0)
                {
                    tags = tags + '|';
                }
                tags = tags + encodeURIComponent($(this).text());
            });

            var startdate = '';
            var enddate = '';
            if (getfilterstartdate() != null) {
                startdate = $('[data-key="' + start_date_key + '"] input.hasDatepicker').datepicker({ dateFormat: 'yy-mm-dd' }).val();;
            }

            if (getfilterenddate() != null) {
                enddate = $('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker({ dateFormat: 'yy-mm-dd' }).val();;
            }
            var page = Math.ceil(childPages.i / pagesize);


            var fsdate = '';
            if (startdate.length > 0)
            {
                fsdate = "&fsdate=" + startdate;
            }

            var fedate = '';
            if (enddate.length > 0)
            {
                fedate = "&fedate=" + enddate;
            }

            history.pushState({ ftag: tags, fsearch: input, fpage: page, fsdate: startdate, fedate: enddate}, null, "?fsearch=" + input + "&ftag=" + tags + "&fpage=" + page + fsdate + fedate);
        }

        $('#search-input').keydown(function() {
            clearTimeout(searchtimeout);
            searchtimeout = setTimeout(function() {
                setfilterstate();
            }, 500)
        });

        $('#search-input').keyup(function() {
            countNumberOfListItems();
        });

        window.addEventListener('popstate', function(e) {

            if (e.state != null)
            {
                var fsearch = decodeURIComponent(e.state.fsearch);
                var ftag = decodeURIComponent(e.state.ftag);
                var fsdate = decodeURIComponent(e.state.fsdate);
                var fedate = decodeURIComponent(e.state.fedate);
                var fpage = e.state.fpage;

                $('.gk-filter-search-widget').find('.search').val(fsearch);
                $('.tag-list > li').removeClass('active');

                if (getfilterstartdate()) {
                    $('[data-key="' + start_date_key + '"] input.hasDatepicker').datepicker('setDate', fsdate);
                }
                if (getfilterenddate()) {
                    $('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('setDate', fedate);
                }

                var tags = ftag.split('|');
                var i;
                for (i = 0; i < tags.length; i++) {
                    var item = $(".tag-list").find("[data-sort='" + tags[i] + "']");
                    item.addClass('active');
                }

                childPages.search(fsearch);
                filterPagesInList(false);

                childPages.show(((fpage - 1) * pagesize) + 1, pagesize);
            }
            else {
                //reset all
                $('.gk-filter-search-widget').find('.search').val('');
                $('.tag-list > li').removeClass('active');
                if (getfilterstartdate()) {
                    $('[data-key="' + start_date_key + '"] input.hasDatepicker').datepicker('setDate', new Date());
                }
                if (getfilterenddate()) {
                    $('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('setDate', null);
                }
                
                filterPagesInList(false);
                childPages.search();
            }

        });


        function handleFilterInputParameters() {
            if (getParameterByName('fsearch') || getParameterByName('ftag') || getParameterByName('fsdate') || getParameterByName('fedate')) {
                if (!$('.show-hide-filters').hasClass('open')) {
                    $('.show-hide-filters').trigger('click');
                }
            }

            if (getParameterByName('fsearch')) {
                $('.gk-filter-search-widget').find('.search').val(decodeURIComponent(getParameterByName('fsearch')));
                childPages.search(getParameterByName('fsearch'));
            }

            if (getParameterByName('fsdate') && (getfilterstartdate() != null)) {
                var sdate = decodeURIComponent(getParameterByName('fsdate'));
                $('[data-key="' + start_date_key + '"] input.hasDatepicker').datepicker('setDate', sdate);
            }

            if (getParameterByName('fedate') && (getfilterenddate() != null)) {
                var edate = decodeURIComponent(getParameterByName('fedate'));
                console.log(edate);
                $('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('setDate', edate);
            }
            else if (getfilterenddate() != null) {
                console.log(getfilterenddate());
                $('[data-key="' + end_date_key + '"] input.hasDatepicker').datepicker('setDate', null);
            }

            if (getParameterByName('ftag')) {
                var tags = decodeURIComponent(getParameterByName('ftag')).split('|');
                var i;
                for (i = 0; i < tags.length; i++) {
                    var item = $(".tag-list").find("[data-sort='" + tags[i] + "']");
                    item.trigger('click');
                }
            }

            if (getParameterByName('fpage')) {
                var page = parseInt(getParameterByName('fpage'))
                childPages.show(((page - 1) * pagesize) + 1, pagesize);
            }

        }

        function countNumberOfListItems() {
            jQuery(function ($) {
                if ($('.gk-filter-number-items-widget').length > 0) {
                    // Check which of the child elements is visible.
                    var elements = childPages.matchingItems.length;
                    // Update counter.
                    $('.shown-number-items').html(elements);
                }
            });
        }

        function getactivetags() {
            // Create empty array.
            var tags = new Array();
            // Check which items are active.
            $('.list-item.sort').each(function () {
                if ($(this).hasClass('active')) {
                    tags.push($(this).data('sort'));
                }
            });
            return tags;
        }

        function getselectedcategory() {
            var category = $('.gk-filters').find('.select-list').children('.active').data('sort');
            return category;
        }

        function getfilterstartdate() {
            var startdate = $('.gk-filter-datepicker-widget').find('[data-name="datepicker_with_todays_date_as_default"]').find('.input.hasDatepicker');

            if (startdate.length == 0)
                return null;

            if (startdate.val() == '' || startdate.val() == null) {
                if (getParameterByName('filterstartdate')) {
                    return Date.parse(getParameterByName('filterstartdate'));
                }
            }
            return Date.parse(startdate.val());
        }

        function getfilterenddate() {

            var enddate = $('.gk-filter-datepicker-widget').find('[data-name="datepicker_without_default_date"]').find('.input.hasDatepicker');
            if (enddate.length == 0)
                return null;
            if (enddate.val() == '' || enddate.val() == null) {
                if (getParameterByName('filterenddate')) {
                    return Date.parse(getParameterByName('filterenddate'));
                }
                return Date.parse('2030-12-31');
            }
            return Date.parse(enddate.val());
        }

        function filterPagesInList(history) {

            history = typeof history !== 'undefined' ? history : true;
            var tags = getactivetags();
            var selectedcategory = getselectedcategory();
            var startdate = getfilterstartdate();
            var enddate = getfilterenddate();
            childPages.filter(function (item) {
                var names = item.values().tags.split("|");
                var tagmatch = false;
                var categorymatch = false;
                var datematch = false;
                var matchcount = 0;

                var taggroups = new Array();
                var groupcheck = false;
                var groupfilter = true;

                $('.gk-filters .tag-list').each(function () {
                        taggroups.push($(this));
                });
                if (taggroups.lenght !== 0 && tags.length !== 0 && !$('.gk-filter-tag-widget').first().hasClass('match-all')) {
                    $.each(taggroups, function (key, group) {
                        if (groupfilter) {
                            groupcheck = false;
                            $.each($(group).children(), function( index, value ) {
                                if ($(value).hasClass('active') && !groupcheck) {
                                    $.each(names, function (i, val) {
                                        if ($(value).data('sort') == val) {
                                            matchcount++;
                                            groupfilter = true;
                                            groupcheck = true;
                                            return false;
                                        } else {
                                            groupfilter = false;
                                        }
                                    });
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                    if ((matchcount > 0 && groupfilter) || (matchcount == tags.length && groupfilter)) {
                            tagmatch = true;
                    }
                } else if(tags.length !== 0) {
                            $.each(tags, function( key, selectedtag ) {
                                    $.each(names, function (i, val) {
                                        if (selectedtag == val) {
                                            matchcount++;
                                            return false;
                                        }
                                    });
                            });
                            if(matchcount == tags.length) {
                                tagmatch = true;
                            }
                } else {
                    tagmatch = true;
                }
                if (selectedcategory == null || selectedcategory.length == 0)
                    categorymatch = true;
                else {
                    var categories = item.values().categories.split("|");
                    $.each(categories, function (i, val) {
                        if (selectedcategory == val) {
                            categorymatch = true;
                            return false;
                        }
                    });
                }
                if ((startdate == null || startdate.length == 0 || isNaN(startdate)) || (enddate == null || enddate.length == 0)) {
                    datematch = true;
                }
                else {
                    var cstartDate = Date.parse(item.values().startdate);
                    var cendDate = Date.parse(item.values().enddate);
                    if ((cstartDate <= enddate && cstartDate >= startdate) || (cendDate <= enddate && cendDate >= startdate) || (cendDate >= enddate && cstartDate <= startdate)) {
                        datematch = true;
                    }
                }
                return (tagmatch && categorymatch && datematch);
            });
            if ($('body').hasClass('page-template-page_eventcalendar')) {
                childPages.sort('startdate', {order: "asc"});
            }
            else {
                childPages.sort('gk-item-title', { alphabet: "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvXxYyZzÅåÄäÖö" });
            }
            countNumberOfListItems();
            if (history) {
                setfilterstate();
            }
        }

    }

    $('body').on('click', '#tribe-tickets-attendee-consent', function () {
        if ( $('.tribe-events-tickets').hasClass('tribe-tickets-has-consent') ) {
            $('.tribe-events-tickets').removeClass('tribe-tickets-has-consent');
        } else {
            $('.tribe-events-tickets').addClass('tribe-tickets-has-consent');
        }
    });

    $('body').on('click', '.hours-by-day', function(e){
        e.preventDefault();

        if( $(this).hasClass('open') ){
            $(this).removeClass('open');
        } else {
            //ga('send', 'event', 'hours', 'open');
            $(this).addClass('open');
        }
    });

    $('[data-async-src]').each(function() {
        $(this).attr('src', $(this).data('async-src'));
    });

    // When text input in filter box is focused.
    $('.gk-filter input[type="text"]').focus(function(){
        $(this).parents('.gk-filter').addClass('focused');
    }).blur(function(){
        $(this).parents('.gk-filter').removeClass('focused');
    });

    // Check if input has text.
    $('.gk-filter input[type="text"]').keyup(function(){
        if( $(this).val().length > 0 ) {
            $(this).parents('.gk-filter').removeClass('is-empty');
        } else {
            $(this).parents('.gk-filter').addClass('is-empty');
        }
        //countNumberOfListItems();
    });

    // Show and hide filters on list child pages template.


    // When select field is clicked.
    $('.gk-filter-select-widget .selected-value').click(function(){
        $(this).parent().find('.select-list').fadeIn(150);
    });
    // When field is clicked using "Enter" key.
    $('.gk-filter-select-widget .selected-value').keypress(function(e){
        if(e.which == 13){//Enter key pressed
            $(this).click();//Trigger search button click event
        }
    });
    // When a select item is clicked.
    $('.gk-filter-select-widget .select-item').click(function(){
        if( !$(this).hasClass('active') ){
            var sort_url = $(this).data('sort');
            var sort_name = $(this).data('name');
            $('.select-item').removeClass('active');
            $(this).addClass('active');
            $(this).parents().eq(2).find('.selected-value').html(sort_name);
        }
        $(this).parent().fadeOut(150);
    });

    // When field is clicked using "Enter" key.
    $('.gk-filter-select-widget .select-item').keypress(function(e){
        if(e.which == 13){//Enter key pressed
            $(this).click();//Trigger search button click event
        }
    });

    $('.feedback-button').click(function (e) {

        e.preventDefault();

        var $this = $(this);
        var page = $this.data("page");
        var feedback = $this.data("feedback");
        var focus = $this.data("set-focus");

        // If the clicked button is disabled, exit...
        if($this.attr('disabled') && $this.attr('disabled') == 'disabled'){
            return false;
        }

        $this.addClass('active');

        if (feedback == false) {
            // Feedback "NEJ".
            //ga('send', 'event', 'feedback', 'nej');

            $('.feedback-form').removeClass("hidden");  
            $('.customer-service-container').removeClass("hidden");

            if(focus && focus.length > 0) {
                $(focus).focus();
            }
        } else {
            // Feedback "JA".
            //ga('send', 'event', 'feedback', 'ja');

            $this.parent().append("<p class='result'>Tack för din synpunkt!<span>Här nedanför hittar du kontaktuppgifterna till vår kundtjänst som kan hjälpa dig att komma vidare med ditt ärende.</span></p>");
        }

        var data = {
            'action': 'feedback_savevote',
            'positive': feedback,
            'pageid': page
        };

        $.post('/wp-admin/admin-ajax.php', data, function(response) {

        });

        // Disable both buttons when clicked the first time
        $(".feedback-button").attr('disabled', 'disabled');

    });

    $('.feedback-text-button').click(function (e) {
        e.preventDefault();
        $(this).attr('disabled', 'disabled');
        var $form = $('#feedback-text-form');
        $.post($form.attr('action'), $form.serialize(), function(data) {
        }, 'json');

        $form.parent().addClass("hidden");
        $('.feedback-controls').first().append("<p class='result'>Tack för din synpunkt!<span>Här nedanför hittar du kontaktuppgifterna till vår kundtjänst som kan hjälpa dig att komma vidare med ditt ärende.</span></p>");
    });



    $('.gk_togglediv').on('show.bs.collapse', function(e)
    {
        //var newstep = $(this).find('a').attr('href');
        var newstep = $(this).find('a').data("expandid");
        //newstep = newstep.substring(newstep.lastIndexOf('_')+1);
        if ($.isNumeric(newstep)) {
            var step = getParameterByName('step');
            if (step != null && step != '')
            {
                var steps = step.split(',');
                if ($.inArray(newstep.toString(),steps) == -1) {
                    steps.push(newstep);
                    steps.sort();
                    updateQueryStringParam('step', steps.join());
                }
            }
            else {
                updateQueryStringParam('step', newstep);
            }
        }
    });

    $('.gk_togglediv').on('hide.bs.collapse', function(e)
    {
        var newstep = $(this).find('a').data("expandid");
        //newstep = newstep.substring(newstep.lastIndexOf('_')+1);
        if ($.isNumeric(newstep)) {
            var step = getParameterByName('step');
            if (step != null)
            {
                var steps = step.split(',');
                if ($.inArray(newstep.toString(),steps) != -1) {
                    var stepindex = steps.indexOf(newstep.toString());
                    if (stepindex > -1) {
                        steps.splice(stepindex, 1);
                    }
                    if (steps.length > 0) {
                        updateQueryStringParam('step', steps.join());
                    }
                    else {
                        removeParam('step');
                    }
                }
            }
            else {
                updateQueryStringParam('step', newstep);
            }
        }
    });

    $('.post-video-overlay').on('click', function(ev) {
        var iframe = $(this).parent().find('iframe');

        if ( $(this).hasClass('youtube') ) {
            iframe[0].src += "&autoplay=1";
        } else if ( $(this).hasClass('vimeo') ) {
            var player = new Vimeo.Player(iframe);
            player.play();
        }

        $(this).parent().find('img').remove();
        $(this).remove();
    });


    //bindModalLoginButtons();

    setTableOfContents();
    showOnlyFirstXItems(5);
    unspecifiedCode();

    //checkForPendingComment();
    //checkForRateCommand();
    expandSelectedStepsInExpandableModule();

    $('#cancel-comment-reply-link').click(function() {
        $('.comment-reply-link').removeClass('disabled');
        $('#comment').val('');
        return true;
    });

    $('.comment-reply-link').click(function() {
        $('.comment-reply-link').removeClass('disabled');
        $(this).addClass('disabled');
        return true;
    });

    $('.comment-respond #submit').click(function() {
        if ($('#comment').val() == '')
        {
            return false;
        };
        return true;

    });

    $('#comment').on('propertychange input', function (e) {
        var valueChanged = false;

        if (e.type=='propertychange') {
            valueChanged = e.originalEvent.propertyName=='value';
        } else {
            valueChanged = true;
        }
        if (valueChanged) {
            $(this).height(5);
            $(this).height(($(this)[0].scrollHeight-14));
        }
    });
    
    function unspecifiedCode()
    {
        // Set results view on tag page
        $('.set-view').click(function (e) {

            e.preventDefault();

            if ($(this).attr('id') == 'card-view') {
                $('.set-view').removeClass('active');
                $(this).addClass('active');
                $('#mainBodyDiv, #list-id').removeClass('list-view');
            } else {
                $('.set-view').removeClass('active');
                $(this).addClass('active');
                $('#mainBodyDiv, #list-id').addClass('list-view');
            }
        });


        /* When all is loaded */
        $(window).on("load", function() {
            // weave your magic here.
            /*make images adapt to its parent container*/
            $(".responsive-img").each(function () {

                var imgH = $(this).find('img').height();
                var imgW = $(this).find('img').width();

                if (imgH > imgW) {
                    $(this).addClass("portrait");
                } else if(imgH == imgW) {
                    $(this).addClass("square");
                } else {
                    $(this).addClass("landscape");
                }
            });
        });



        /*make images adapt to its parent container
        $(".responsive-img").each(function () {
            var refH = $(this).height();
            var refW = $(this).width();
            var refRatio = refW / refH;

            var imgH = $(this).children("img").height();
            var imgW = $(this).children("img").width();
            var imgRatio = imgW / imgH;

            if (imgRatio < refRatio) {
                $(this).addClass("portrait");
            } else {
                $(this).addClass("landscape");
            }
        });
        */

        /* disable scroll on mobile-menu open */
        $('#menu-state').click(function () {
            if ($(this).is(':checked')) {
                if ($(window).scrollTop() !== 0) {
                    $("html, body").animate({scrollTop: "0px"}, 100);
                    $('html').delay(100).queue(function () {
                        $(this).addClass('no-scroll').dequeue();
                    });
                } else {
                    $('html').addClass('no-scroll');
                }
            } else {
                $('html').removeClass('no-scroll');
            }
        });

        $("[data-share-count='true']").each(function (i) {
            var current = $(this);
            var url = window.location.hostname;
            // Tillfälligt för demo
            url = getDemoUrlForSocial();
            current.text('');

            //TODO: Fixa en accesstoken och använd denna kod istället
            /* $.getJSON('https://graph.facebook.com/?id=http://' + url, function (data) {
             current.text('' + (data.shares || 0));
             }); */

        });


        /* Comment function api requests */
        $('.comment-button').click(function (e) {
            e.preventDefault();
            $(".comment-button").attr('disabled', 'disabled');
            var pageid = $('#page-comment').attr('class').replace('page-comment-', '');
            var comment = document.getElementsByName("comment")[0].value;
            $.post('/api/comment', {'pageID': pageid, 'commentText': comment});

        });

        $('.comments .vote').click(function (e) {
            e.preventDefault();
            var action = $(this).data("action");
            var upvote = (action === "upvote");
            var commentid = $(this).closest('li').attr('id').replace('comment-', '');
            $.post('/api/commentvote', {'isUpVote': upvote, 'PageCommentID': commentid});

            var count = +($(this).closest('li').find('.count').text());

            if (upvote) {
                count = count + 1;
            }
            else {
                count = count - 1;
            }
            $(this).closest('li').find('.count').text(count);

        });

        $('.comments .flag').click(function (e) {
            e.preventDefault();
            var commentid = $(this).closest('li').attr('id').replace('comment-', '');
            $.post('/api/comment/flag/' + commentid);
            $(this).text("Flagged");

        });


        $('.comments .modify').click(function (e) {
            e.preventDefault();
            var action = $(this).data("action");
            var commentid = $(this).closest('li').attr('id').replace('comment-', '');
            if (action === "remove") {
                $.post('/api/comment/remove/' + commentid);
                $(this).text("RADERAD");
            }
            else if (action === "edit") {
                var comment = "Detta är den redigerade kommentaren";
                $.post('/api/comment/edit', {'ID': commentid, 'commentText': comment});
                $(this).text("REDIGERAD");
            }

        });

        $('.comments .reply').click(function (e) {
            e.preventDefault();
            var commentid = $(this).closest('li').attr('id').replace('comment-', '');
            if ($(this).closest('li').find('.replycomment').length == 0) {
                var input = $("<div class='replycomment'><textarea rows='3' cols='20'></textarea><input type='button' class='btn btn-default btn-reply' name='send' value='Skicka' /></div>");
                $(this).parent().append(input);
            }

        });
        $('.comments').on('click', '.btn-reply', function (e) {
            e.preventDefault();
            var pageid = $('#page-comment').attr('class').replace('page-comment-', '');
            var commentid = $(this).parent().closest('li').attr('id').replace('comment-', '');
            var comment = $(this).parent().find('textarea').val();
            $.post('/api/comment', {'pageID': pageid, parentID: commentid, 'commentText': comment});
        });

        $('.article-load-more').click(function (e) {
            e.preventDefault();

            var hidden = $(this).closest('section').find('.hidden');
            //console.log(hidden);
            hidden.removeClass('hidden');
        });

        $('.tribe-section-taxonomy .tag-list .list-item').click(function (e) {
            if( !$(this).hasClass('disabled') ) {
                var catinput = $(this).closest('.tribe-section-taxonomy').find('.GK_hidden_input');
                var value = $(this).data('value').toString();
                var result = catinput.val().split(',');
                var index = result.indexOf(value);
                if (index > -1) {
                    result.splice(index, 1);
                    catinput.val(result.join(","));
                }
                else {
                    result.push(value);
                }
                catinput.val(result.filter(String).join(","));
                $(this).toggleClass('active');
            }
        });


        $('.event-report-link').click( function( e ) {
            e.preventDefault();
            if ( $('.event-report-box').hasClass('open')) {
                $('.event-report-box').removeClass('open').slideUp(200);
            } else {

                $('.event-report-box').addClass('open').slideDown(200);
                if ( $('.event-report-box').hasClass('hidden')) {
                    $('.event-report-box').removeClass('hidden');
                }
            }
        });

        $('#event-report-form .tag-list .list-item').keypress(function(e){
            if(e.which == 13){//Enter key pressed
                $(this).click();//Trigger search button click event
            }
        });

        $('.event-report-box-form .tag-list .list-item').click(function () {
            var catinput = $(this).closest('.event-report-box-form').find('.GK_hidden_input');
            var value = $(this).data('value').toString();
            catinput.val(value);

            $(this).parent().find('.list-item').each(function() {
                $(this).removeClass('active');
            });
            $(this).addClass('active');

        });

        $('.event-report-button').click(function (e) {
            e.preventDefault();
            $(this).attr('disabled', 'disabled');
            var $form = $('#event-report-form');
            $.post($form.attr('action'), $form.serialize(), function(data) {
            }, 'json');
            $('.event-report-box-form').addClass('hidden');
            $('.event-report-box-message').removeClass('hidden');
        });



        $('.post-meta a[href*="#"]:not([href="#"]), .table-of-contents a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 130
                    }, 800);
                    return false;
                }
            }
        });

        $('.carousel-inner div').first().addClass('active');

        // Carousel progress bar

        var percent = 0;
        var bar = $('.transition-timer-carousel-progress-bar');
        var crsl = $('#carousel');
        var pp = $('.pause-play');
        var play = true;

        function progressBarCarousel() {
            bar.css({width:percent+'%'});
            if(play){
                percent = percent + 0.3;
            }
            if (percent>100) {
                percent=0;
                crsl.carousel('next');
            }
        }
        crsl.carousel({
            interval: false,
            pause: false
        }).on('slid.bs.carousel', function () {});var barInterval = setInterval(progressBarCarousel, 30);

        $('.carousel-indicators li').click(function(){
            percent = 0;
        });

        pp.toggle(
            function(){
                play = false;
                clearInterval(barInterval);
                $('.carousel .play').show();
                $('.carousel .pause').hide();
            },
            function(){
                play = true;
                barInterval = setInterval(progressBarCarousel, 30);
                $('.carousel .play').hide();
                $('.carousel .pause').show();
            });
    }

    function getDemoUrlForSocial() {
        var urls = ["www.gavle.se/Utbildning--barnomsorg/", "www.gavle.se/Omsorg--hjalp/", "www.gavle.se/Uppleva--gora/", "www.gavle.se/Bygga-bo-miljo/", "www.gavle.se/Trafik--infrastruktur/", "www.gavle.se/Naringsliv--arbete/", "www.gavle.se/Kommun--politik/"];
        var url = urls[Math.floor(Math.random() * urls.length)];
        return url;
    }

    function setTableOfContents() {

        if ($('.showtoc').length == 0) {
            return;
        }

        var add = false;
        var html =
            "<div class='table-of-contents-container'>" +
            "<div class='table-of-contents-inner'>" +
            "<h2 class='table-title'>Innehållsförteckning</h2>" +
            "<ul class='table-of-contents'>";

        var $this, $parent, title, link, count = 0;

        $(".showtoc h2").each(function () {

            $this = jQuery(this);
            if(includeInToc($this)) {

                title = $this.text();
                link = "#toc-" + ++count;

                $this.attr("id", "toc-" + count);

                html += '<li><a href="' + link + '">' + title + '</a></li>';

                add = true;
            }
        });

        html += "</ul></div></div>";

        if(add) {
            $(".showtoc").prepend(html);
        }
    }

    function includeInToc($item)
    {
        $parent = $item.parent();

        //Exclude feedback title
        if ($parent.hasClass('feedback-content'))
            return false;

        //Exclude event titles
        if ($item.hasClass('tribe-events-list-event-title'))
            return false;

        //Exclude titles in toggles
        if ($item.parents('.gk_togglediv').length)
            return false;

        return true;
    }


    function showOnlyFirstXItems(count) {

        $(".limit-list").each(function () {
            var $lis = $("li", this).hide();
            $lis.slice(0, count).show();
            //console.log('list found');
            if ($lis.length <= count) {
                $(this).next('.show-more').hide();
            }
        });

        $('.limit-list-sm').click(function (e) {
            e.preventDefault();
            var $ll = $(this).prev(".limit-list");
            $ll.children('li').show();
            //console.log($ll.count);
            $(this).hide();
        });


    }

    function bindModalLoginButtons() {

        $(".comment-reply-login").each(function () {
            $(this).click(function (e) {
                e.preventDefault();
                var commentId = $(this).parents('.comment-body:first').attr('id');
                var date = new Date();
                date.setTime(date.getTime() + (5 * 60 * 1000));
                Cookies.set("commentId", commentId, { expires: date });
                $('#a0LoginButton').click();
            });
        });
    }

    function checkForPendingComment()
    {
        var commentId = Cookies.get("commentId");
        Cookies.remove("commentId");

        if(commentId!=null && commentId==$("#" + commentId).attr("id"))
        {
            //console.log("Commenting on " + commentId);

            const element = $("#" + commentId + " .comment-reply-link")[0];
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2);

            $(window).load(function(){
                window.scrollTo(0, middle);
                //$("#" + commentId + " .comment-reply-link")[0].onmouseover();
                $("#" + commentId + " .comment-reply-link")[0].click();
            });
        }
    }

    function checkForRateCommand()
    {
        var rateCommandPost = Cookies.get("rateCommandPost");
        var rateCommandStars = Cookies.get("rateCommandStars");
        Cookies.remove("rateCommandPost");
        Cookies.remove("rateCommandStars");

        if(rateCommandPost!=null && rateCommandPost==$("article").attr('id'))
        {
            //console.log("Recieved the rate command: "+rateCommandStars + " stars. Clicking star.");
            var rateStars = parseInt(rateCommandStars);
            if(rateStars==0)
                return;
            //post_id = rateStars;
            post_id = $("article").attr('id');
            post_rating = rateStars;
            initiatedFromCode=true;

            //var top =$( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].documentOffsetTop() - ( window.innerHeight / 2 );

            const element = $( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0];
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 2);

            $(window).load(function(){
                window.scrollTo(0, middle);
                //$( ".post-ratings" ).effect( "shake", { direction: "up", times: 2, distance: 2} );
                $( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].onmouseover();
                $( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" ).click();
            });



            //$( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].scrollIntoView();
            //$( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].onmouseover();
            //$( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" ).click();

            /*setTimeout( function(){
                //$.scrollTo(".rate-and-share .post-ratings a:nth-child("+rateStars+")", 500, {offset: -$(window).height() /2});
                $('html, body').animate({
                    scrollTop: middle
                }, 600, "easeInOutCubic");
                setTimeout(
                    function() {
                        $( ".post-ratings" ).effect( "shake", { direction: "up", times: 3, distance: 2} );
                        //$( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].scrollIntoView();
                        $( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" )[0].onmouseover();
                        $( ".rate-and-share .post-ratings a:nth-child("+rateStars+")" ).click();
                    }, 400);


            }  , 500 );*/

        }
    }

    /**
     * Open mobile menu.
     */
    $('body').on('click', '#menu-toggle', function(){
        $('html').addClass('disable-scroll');
        $('body').addClass('menu-toggled');
    });

    /**
     * Close mobile menu when overlay is scrolled.
     */
    $('body').on('touchmove', '.menu-close-overlay', function() {
        $('html').removeClass('disable-scroll');
        $('body').removeClass('menu-toggled');
    });

    /**
     * Close menu when dark overlay is clicked.
     */
    $('body').on('click touchend', '.menu-close-overlay', function(e) {
        e.stopPropagation(); e.preventDefault();
        $('body').removeClass('menu-toggled');
        $('html').removeClass('disable-scroll');
    });

    /**
     * Check if the active menu item has a dropdown, if thats the case open it.
     */
    $(document).ready(function(){
        $('.menu-item').each(function() {
            if ($(this).hasClass('dropdown-toggled')) {
                $(this).find('.sub-menu-container').css('display', 'block').find('.sub-menu').addClass('opened');
            }
        });
    });

    $('body').on('click', '.pagination', function(){
        var scrollTo = $('.gk-item-list').offset().top - 150;
        $('html, body').animate({scrollTop: scrollTo}, 300);
    });

    /**
     * Open and close dropdown in menu.
     */
    $('body').on('click', '.dropdown-toggle', function(){

        var $parent = $(this).parent();
        var $subMenu = $parent.find('.sub-menu');
        var $subMenuContainer = $parent.find('.sub-menu-container');

        if ($parent.hasClass('dropdown-toggled')) {
            $parent.removeClass('dropdown-toggled');
            $subMenu.css('margin-top', -checkElementHight($subMenu)).attr('aria-hidden', true);
            $subMenuContainer.delay(200).queue(function(next){
                $(this).hide();
                next();
            });
        } else {
            $parent.addClass('dropdown-toggled');
            $subMenuContainer.show();
            $subMenu.css('margin-top', -checkElementHight($subMenu));
            $subMenu.delay().queue(function(next){
                $subMenu.addClass('opened');
                $(this).css('margin-top', 0).attr('aria-hidden', false);
                next();
            });
        }
    });


    /**
     * Open and close dropdown your-page.
     */
    $('body').on('click', '#toggle-dropdown-your-page', function(){

        var $parent = $(this).parent();
        var $subMenu = $parent.find('.dropdown-menu');
        var $subMenuContainer = $parent.find('.dropdown-container');
        var $button =  $('#toggle-dropdown-your-page');

        if ($parent.hasClass('dropdown-toggled')) {
            $button.attr('aria-hidden', 'true');
            $parent.removeClass('dropdown-toggled');
            $('body').removeClass('your-page-toggled');
            $subMenu.css('margin-top', -checkElementHight($subMenu)).attr('aria-hidden', true);
            $subMenuContainer.delay(200).queue(function(next){
                $(this).hide();
                next();
            });
        } else {
            $parent.addClass('dropdown-toggled');
            $subMenuContainer.show();
            $button.attr('aria-hidden', 'false');
            $('body').addClass('your-page-toggled');
            $subMenu.css('margin-top', -checkElementHight($subMenu));
            $subMenu.delay().queue(function(next){
                $subMenu.addClass('opened');
                $(this).css('margin-top', 0).attr('aria-hidden', false);
                next();
            });
        }
    });


    $('body').on('click', '.gk-item-place-more-about-toggle', function(){
        var parent = $(this).parent('.gk-item-place-more-about-container');

        if ( parent.hasClass('open') ) {
            parent.removeClass('open');
        } else {
            parent.addClass('open');
        }
    });


    /**
     * Remove your page dropdown when backdrop is clicked.
     */
    $('body').on('click', '#your-page-backdrop', function(){

        var $parent = $('.your-page');
        var $subMenu = $parent.find('.dropdown-menu');
        var $subMenuContainer = $parent.find('.dropdown-container');
        var $button =  $('#toggle-dropdown-your-page');

        $button.attr('aria-hidden', 'true');
        $parent.removeClass('dropdown-toggled');
        $('body').removeClass('your-page-toggled');
        $subMenu.css('margin-top', -checkElementHight($subMenu)).attr('aria-hidden', true);
        $subMenuContainer.delay(200).queue(function(next){
            $(this).hide();
            next();
        });
    });


    $('body').on('click', '.gk-temp-header', function(){
        $(this).toggleClass('open');
    });

    /**
     * Check height of a element.
     * @param $element
     * @returns {*}
     */
    function checkElementHight($element){
        $value = $element.prop('offsetHeight');

        return $value;
    }

    $('body').on('click', '.go-to-wp-booking', function(e){
        e.preventDefault();
        var target = $('#tribe-rsvp-form');

        if( target.length ) {
            $('html, body').animate({
                scrollTop: target.offset().top - 130
            }, 800);
        }
    });
});

function googleTranslateElementInit() {

    var pageLanguage = 'sv';

    if(location.href.indexOf('/suomeksi') > 0) {
        pageLanguage = 'fi';
    }

    new google.translate.TranslateElement({
            pageLanguage: pageLanguage,
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false
        },
        'google_translate_element');
}


var removeValue = function(list, value, separator) {
    separator = separator || ",";
    var values = list.split(separator);
    for(var i = 0 ; i < values.length ; i++) {
        if(values[i] == value) {
            values.splice(i, 1);
            return values.join(separator);
        }
    }
    return list;
};



(function($) {

    $('.btn.event-list-link').click(function () {
        $this = $(this);
        $container = $this.closest('.module-container');

        if($('.module-view', $container).is(':visible')) {
            $('.module-view', $container).hide();
        }
        else {
            $('.module-view', $container).show();
        }
        return false;
        
        /*$view = $('<div />', { 'class': 'module-view' }); 

        // TODO: Get attendes
        $view.text('teadtasdtas')

        $('.module-view', $container).remove();
        $container.append($view);

        return false;*/
    });
    $('.btn-with-confirm').click(function (e) {
        var message = "Är du säker?";
        if($(this).data('confirm-message')) {
            message = $(this).data('confirm-message');
        }
        if(!window.confirm(message)) {
            e.preventDefault();
            return false;
        }
    });

   var lastScrollTop = 0, delta = 5;
   $(window).scroll(function(){
       var nowScrollTop = $(this).scrollTop();
       if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
           if (nowScrollTop > lastScrollTop){
                // ACTION ON
                // SCROLLING DOWN
                $( "#cookie-notice" ).css("transition", "transform .375s ease-out,opacity .15s ease-out");
                $( "#cookie-notice" ).css("transform", "translateY(100%)"); 
           } else {
                // ACTION ON
                // SCROLLING UP
                $( "#cookie-notice" ).css("transition", "transform .375s ease-in,opacity .15s ease-in");
                $( "#cookie-notice" ).css("transform", "translateY(0%)"); 
          }
       lastScrollTop = nowScrollTop;
       }
   });

   $(".gk-feedback-send-comment").click(function(){
        $(".gk-vizzit-form-content").show();
        $(".gk-pick-feedback").hide();
  });
  $(".gk-feedback-send-back").click(function(){
    $(".gk-vizzit-form-content").hide();
    $(".gk-pick-feedback").show();
});

$( ".gk-item-place-meta .availability" ).on( "click", function() {
    $(this).find("i").toggleClass("fa-caret-up");
});

})(jQuery);

var notice = function() {

    var accepted = false;

    function set_cookie(name, value, days) {
        var exp = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            exp = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + exp + "; path=/";
    }

    function get_cookie(name) {
        var val = name + "=";
        var arr = document.cookie.split(';');
        for(var i=0;i < arr.length;i++) {
            var c = arr[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(val) == 0) return c.substring(val.length,c.length);
        }
        return null;
    }
    
    function del_cookie(name) {   
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    function set_notice_style(val) {
        document.getElementById('gk-notice').style.display = val;
    }

    return {

        accept: function() {
            set_cookie('gk_notice_accepted', true, 365);
            set_notice_style('none');
        },
        init: function () {
            
            var accepted = get_cookie('gk_notice_accepted');

            if(accepted) {

                set_notice_style('none');
            }
            else {
                
                set_notice_style('block');
            }
        }
    };

}();

notice.init();